














import { Component, Vue } from 'vue-property-decorator';
import Headline from '@/components/school/sections/Headline.vue';
import Headline2 from '@/components/school/sections/Headline2.vue';
import LessonPlan from '@/components/school/sections/LessonPlan.vue';
import Teacher from '@/components/school/sections/Teacher.vue';
import Curriculum from '@/components/school/sections/Curriculum.vue';
import Student from '@/components/school/sections/Student.vue';
import SchoolYear from '@/components/school/sections/SchoolYear.vue';
import LessonTemplates from '@/components/school/sections/LessonTemplates.vue';
import Signup from '@/components/core/Signup.vue';

@Component({
  components: {
    Headline,
    Headline2,
    LessonPlan,
    Teacher,
    Curriculum,
    Student,
    SchoolYear,
    LessonTemplates,
    Signup
  }
})
export default class School extends Vue {
}
